import { clsx } from 'clsx'
import type { HTMLAttributes } from 'react'

type Props = HTMLAttributes<HTMLElement> & {
  /** Optional two-digit step numeral shown before the label, e.g. "02". */
  numeral?: string
  tone?: 'default' | 'muted' | 'inverse'
  as?: 'p' | 'span' | 'div'
}

/** Small uppercase tracked label used above headings, matching the site's section markers. */
export function Eyebrow({ numeral, tone = 'default', as: Tag = 'p', className, children, ...rest }: Props) {
  return (
    <Tag
      className={clsx(
        'font-body text-eyebrow uppercase tracking-eyebrow font-medium',
        tone === 'default' && 'text-ink',
        tone === 'muted' && 'text-dim',
        tone === 'inverse' && 'text-paper/80',
        className,
      )}
      {...rest}
    >
      {numeral && <span className="mr-3 tabular-nums">{numeral}</span>}
      {children}
    </Tag>
  )
}
